import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";

// Import Elements
import Table from "../../../common/element/Table";
import Button from "../../../common/element/Buttons";
import ThreeDotBouncingLoader from "../../../common/element/ButtonLoader/ThreeDotBouncingLoder";

// Import Modals
import ArchiveModal from "../../../common/Common/ArchiveModal";
import DeleteModal from "../../../common/Common/DeleteModal";

// Import SweetAlert
import SweetAlertService from "../../../common/SweetAlert/SweetAlert";

// Import the delete action
import { deleteBatches } from "../../../redux/Batches/batchSlice";
import CommonIconButton from "../../../common/icons/CommonIconButton";

const { Tr, Th, Td, THead, TBody } = Table;

const BatchList = ({ batches, onEdit, batchesLoading, fetchBatches, companyId, isAdmin }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // State for modal visibility
  const [isOpen, setIsopen] = useState(false);
  // State to store the ID of the batch to be deleted
  const [deleteId, setDeleteId] = useState(null);

  // Handler to open modal and set the specific ID
  const openDeleteModal = (id) => {
    setDeleteId(id);
    setIsopen(true);
  };

  // Handler to execute the delete action
  const handleDelete = async () => {
    if (deleteId) {
      try {
        // Unwrap returns the action payload on success (HTTP 200)
        const response = await dispatch(deleteBatches({ id: deleteId, company_id: companyId ? Number(companyId) : null })).unwrap();
        console.log(response, "responseresponse")
        // Check if the API response explicitly indicates failure (status: false)
        if (response?.success === false || response?.statusCode === 409) {
          // Show Error Alert if status is false
          SweetAlertService.showError({
            title: "Error",
            message: response?.message || "Failed to delete batch",
          });
        } else {
          // Show Success Alert with the message from the API
          const successMessage = response?.message || "Batch deleted successfully";

          SweetAlertService.showSuccess({
            title: "Deleted",
            message: successMessage,
          });

          // Refresh the list to show updated data
          if (fetchBatches) {
            fetchBatches();
          }
        }
      } catch (error) {
        // Handle HTTP Errors (400, 500) or Redux Rejection
        SweetAlertService.showError({
          title: "Error",
          message: error || "Failed to delete batch",
        });
      } finally {
        // Close modal and reset ID
        setIsopen(false);
        setDeleteId(null);
      }
    }
  };

  return (
    <div className="border rounded-lg border-gray-200">
      <Table>
        <THead>
          <Tr className="text-start" style={{ backgroundColor: "#FFF4E5" }}>
            <Th className="text-start">S No.</Th>
            <Th className="text-start">Batch Name</Th>
            <Th className="text-start">Employee Count</Th>
            <Th className="text-start">Last Session Date</Th>
            <Th>Action</Th>
          </Tr>
        </THead>

        <TBody>
          {batchesLoading ? (
            <Tr>
              <Td colSpan={5} className="text-center py-6">
                <ThreeDotBouncingLoader />
              </Td>
            </Tr>
          ) : batches?.length > 0 ? (
            batches.map((item, index) => (
              <Tr key={item.id || index} className="text-center">
                <Td className="text-start">
                  {String(index + 1).padStart(2, "0")}
                </Td>
                <Td className="text-start">{item.batch_name}</Td>
                <Td className="text-start">{item.employee_count}</Td>

                <Td className="text-start">
                  {item.last_session_date
                    ? moment(item.last_session_date).format("LL")
                    : "--"}
                </Td>

                <Td>
                  <div className="flex gap-1 ">
                    {/* View Button */}
                    <CommonIconButton
                      type="view"
                      onClick={() => {
                        if (isAdmin && companyId) {
                          navigate(`/companies/companyview?companyId=${companyId}&tab=batch&batchId=${item?.batch_id}&batchName=${item?.batch_name}`);
                        } else {
                          navigate(`/batches/view?batchId=${item?.batch_id}&batchName=${item?.batch_name}`);
                        }
                      }}
                    />



                    {/* Edit and Delete buttons hidden for "Open Batch" */}
                    {item.batch_name?.toLowerCase() !== "open batch" && (
                      <>
                        {/* Edit Button */}
                        <CommonIconButton
                      type="edit"
                          onClick={() => onEdit(item)}
                        />
                      

                        {/* Delete Button */}
                        <CommonIconButton
                          type="delete"
                          onClick={() => openDeleteModal(item.batch_id || item.id)}
                        />
                     
                      </>
                    )}
                  </div>
                </Td>
              </Tr>
            ))
          ) : (
            <Tr>
              <Td
                colSpan={5}
                className="text-center text-gray-500 py-6 text-sm"
              >
                No matching records found
              </Td>
            </Tr>
          )}
        </TBody>
      </Table>

      <DeleteModal
        dialogOpen={isOpen}
        onDialogClose={() => {
          setIsopen(false);
          setDeleteId(null);
        }}
        onConfirm={handleDelete}
        title="Are you sure you want to delete?"
        subtitle="This action cannot be undone."
      />
    </div>
  );
};

export default BatchList;